/* global axios */

import ApiNotifai from './ApiNotifai';

class Flows extends ApiNotifai {
  constructor() {
    super('flows', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }
  
}

export default new Flows();